import bannerBg from "../img/banner-bg.png";
import BookingImgSection from "../img/bookincodeimg1.png"
import BookingImgSection1 from "../img/bookincodeimg2.png"
import BookingImgSection2 from "../img/bookincodeimg3.png"
const styleCss = {
    HeaderStyle: {
        padding: "10px 0px",
        backgroundColor: "#fff",
        position: "fixed",
        width: '100%',
        top: '0px',
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        zIndex: 9,
    },
    CommonTopStyle: {
        marginTop: '90px',
        marginBottom: '50px',
    },
    HomeInnertop: {
        marginTop: '90px',
    },
    HeaderLogosize: {
        width: '135px',
    },
    TicketsMenu: {
        fontSize: "15px",
        fontWeight: 600,
        textAlign: "left",
        color: "#ff5714",
        fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    },
    HeaderRightSide: {
        display: "flex",
        justifyContent: "flex-end"
    },
    HeaderMenustyle: {
        fontFamily: '"Segoe UI", Inter, Roboto, Helvetica, Arial, sans-serif',
        fontSize: "15px",
        textAlign: "center",
        color: "#030213",
        textDecoration: 'none',
    },
    IconAlignstyle: {
        verticalAlign: 'middle',
        marginRight: '5px',
        width: '18px',
    },
    IconAlignstyle1: {
        verticalAlign: 'middle',
        marginRight: '5px',
        width: '17px',
    },
    LoginStyleBtn: {
        padding: "6px 20px",
        borderRadius: "7px",
        backgroundColor: "#ff5714",
        textTransform: "capitalize",
    },
    BannerTopsection: {
        marginTop: "60px",
        marginBottom: '30px',
        backgroundImage: `url(${bannerBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: '100% 100%',
        minHeight: '480px',
        backgroundPosition: 'center',
        "@media (max-width:600px)": {
            backgroundSize: 'cover',
            minHeight: 'auto',
        },
    },
    BannerHeading: {
        fontFamily: "Segoe UI, sans-serif",
        fontSize: "42px",
        fontWeight: "bold",
        textAlign: "center",
        color: "#030213",
        paddingTop: '30px',
        '@media (max-width: 600px)': {
            fontSize: '18px',
            paddingTop: '20px',
        },
    },
    BannerSubtitle: {
        fontFamily: "Segoe UI, sans-serif",
        fontSize: "16px",
        fontWeight: "normal",
        textAlign: "center",
        color: "#364252",
    },
    BannerBoxStyle: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        padding: "20px",
        borderRadius: "22px",
        boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(0, 14, 94, 0.37)",
        backgroundColor: "#fff",
        marginTop: '30px',
        marginBottom: '60px',
        width: '100%',
        margin: '25px auto',
    },
    FromIconalign: {
        verticalAlign: 'middle',
    },
    CommonInputstyle: {
        background: '#f4f4f4',
    },
    BorderBottomStyle: {
        borderBottom: '1px solid red',
        paddingBottom: '20px',
    },
    LocationBtnstyle: {
        padding: "5px 14px",
        borderRadius: "30px",
        backgroundColor: "#ffefe9",
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "13px",
        fontWeight: 600,
        textAlign: "left",
        color: "#ff5714",
        textTransform: 'capitalize',
        "@media (max-width:600px)": {
            marginBottom: '10px',
        },

    },
    RedbusStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "42px",
        fontWeight: "bold",
        textAlign: "center",
        color: "#1d1d1d",
        paddingTop: '30px',
        "@media (max-width:600px)": {
            fontSize: "20px",
            paddingTop: '0px',
        },
    },
    RedparaStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "16px",
        fontWeight: "normal",
        textAlign: "center",
        color: "#364252",
    },
    RedbusStyle1: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "42px",
        fontWeight: "bold",
        textAlign: "center",
        color: "#1d1d1d",
        paddingTop: '20px',
        "@media (max-width:600px)": {
            fontSize: "20px",
        },
    },
    RedparaStyle1: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "16px",
        fontWeight: "normal",
        textAlign: "center",
        color: "#364252",
        marginBottom: '60px',
    },
    Countnumber: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "42px",
        fontWeight: "bold",
        textAlign: "center",
        color: "#1d1d1d",
        marginBottom: '0px',
        lineHeight: '50px',
        "@media (max-width:600px)": {
            fontSize: "20px",
            lineHeight: '30px',
        },
    },
    HappyTextstyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "16px",
        fontWeight: "normal",
        textAlign: "center",
        color: "#364252",
    },
    TravelCompletstyle: {
        padding: '20px 0px 60px',
        backgroundColor: '#f0fdf9',
        marginTop: '70px',
        "@media (max-width:600px)": {
            marginTop: '10px',
            padding: '0px 0px 60px',
        },
    },
    TravelBox: {
        border: "1px solid #e5e5e5",
        backgroundColor: "#fff",
        borderRadius: "13px",
        border: 'solid 1px #e5e5e5',
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
            cursor: "pointer",
        },
    },
    InnerBoxStyle: {
        padding: '10px',
    },
    TrackingHead: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "17px",
        fontWeight: "bold",
        textAlign: "center",
        color: "#0e182b",
        marginBottom: '10px',
        paddingTop: '10px'
    },
    TrackParastyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "16px",
        textAlign: "center",
        color: "#1d1d1d",
        paddingBottom: '10px',
    },
    BookingBox: {
        backgroundImage: `url(${BookingImgSection})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: '100%',
        padding: '25px 20px',
        "@media (max-width:600px)": {
            padding: '30px 20px',

        },
    },
    BookingBox1: {
        backgroundImage: `url(${BookingImgSection1})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: '100%',
        padding: '25px 20px',
        "@media (max-width:600px)": {
            padding: '30px 20px',

        },
    },
    BookingBox2: {
        backgroundImage: `url(${BookingImgSection2})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: '100%',
        padding: '25px 20px',
        "@media (max-width:600px)": {
            padding: '30px 20px',

        },
    },
    FirstStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "20px",
        fontWeight: 900,
        textAlign: "left",
        color: "#fff",
    },
    DiscoundStyle: {
        fontFamily: 'Segoe UI',
        fontSize: '16px',
        textAlign: 'left',
        color: '#b4d1ff',
        paddingTop: '10px',
        paddingBottom: '30px',
        "@media (max-width:600px)": {
            paddingBottom: '5px',
        },
    },
    DiscoundStyle2: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '16px',
        textAlign: 'left',
        color: '#c5ffed',
        paddingTop: '10px',
        paddingBottom: '30px',
        "@media (max-width:600px)": {
            paddingBottom: '5px',
        },
    },
    DiscoundStyle3: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '16px',
        textAlign: 'left',
        color: '#debeff',
        paddingTop: '10px',
        paddingBottom: '30px',
        "@media (max-width:600px)": {
            paddingBottom: '5px',
        },
    },
    CodeStyle: {
        padding: '8px 14px',
        borderRadius: '30px',
        border: '1px solid #71a4f4',
        backgroundColor: '#337eef',
        fontFamily: 'Segoe UI',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#fff',
        marginTop: '8px',
    },
    CodeStyle1: {
        padding: '8px 14px',
        borderRadius: '30px',
        border: '1px solid #33a180',
        backgroundColor: '#33a180',
        fontFamily: 'Segoe UI',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#fff',
        marginTop: '8px',
    },
    CodeStyle2: {
        padding: '8px 14px',
        borderRadius: '30px',
        border: '1px solid #a158ec',
        backgroundColor: '#a158ec',
        fontFamily: 'Segoe UI',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#fff',
        marginTop: '8px',
    },
    WhatStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '42px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: '#1d1d1d',
        lineHeight: '43px',
        paddingBottom: '10px',
        "@media (max-width:600px)": {
            fontSize: '20px',
        },
    },
    StoriesStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '16px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#364252',
    },
    TestmonailsBox: {
        borderRadius: '20px',
        boxShadow: '0 28.9px 63.5px 0 rgba(69, 14, 21, 0.16)',
        backgroundColor: '#fff',
        padding: '0px',
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
        },
    },
    TestimonialsStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '16px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#1d1d1d',

    },
    FeatureStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '16px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#1d1d1d',
        paddingTop: '20px',
        paddingBottom: '50px',
    },
    TestimonailsFooter: {
        padding: '20px 10px',
        backgroundColor: '#1b89ff',
        borderBottomRightRadius: '10px',
        borderBottomLeftRadius: '10px',
    },
    Namestyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        textAlign: 'left',
        color: '#fff',
        alignContent: 'center',
    },
    Subtitle: {
        fontSize: '12px',
        fontWeight: 500,
        fontStretch: 'normal',
        textAlign: 'left',
        color: '#fff',
    },
    DownloadStyle: {
        backgroundImage: 'linear-gradient(179deg, #ff5714 -1%, #db3f00 117%)',
        borderTopLeftRadius: '25px',
        borderTopRightRadius: '25px',
        marginTop: '80px',
        "@media (max-width:600px)": {
            marginTop: '20px',
        },
    },

    ExclusiveStyle: {
        fontSize: '16px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#fff',
    },
    FooterStyle: {
        padding: '54px 0 20px',
        backgroundColor: '#101828',
    },
    FooterText: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#fff',
    },
    DownloadHead: {
        fontSize: '48px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: '#fff',
        "@media (max-width:600px)": {
            fontSize: '20px',
            paddingTop: '20px'
        },
    },
    DownloadStyleHead: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '17px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: '#fff',
        marginTop: '15px',
    },
    QuickLinksstyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '17px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: '#fff',
        marginBottom: '5px',
    },
    QuickLinksstyle1: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '17px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: '#fff',
        marginBottom: '15px',
    },
    Listview: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#fff',
        textDecoration: 'unset'
    },
    MobileFontstyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#fff',
        marginBottom: '10px',
    },
    SaftyHeadStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '17px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#fff',
        marginTop: '10px',
        "@media (max-width:600px)": {
            textAlign: 'left',
        },
    },
    VerificationStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#e3e3e3',
        marginTop: '10px',
        "@media (max-width:600px)": {
            textAlign: 'left',
        },
    },
    StayUpdatedbox: {
        padding: '24px 30px',
        borderRadius: '15px',
        backgroundColor: '#1e2939',
        marginTop: '40px',
    },
    StayUpdatedStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '19px',
        fontWeight: 600,
        textAlign: 'left',
        color: '#fff',
        marginBottom: '5px',
    },
    LatestOffers: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'left',
        color: '#dedede',
    },
    FolloesText: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'left',
        color: '#364252',
    },
    ListFooterBottom: {
        display: 'flex'
    },
    ListviewBottom: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#364252',
        textDecoration: 'unset'
    },
    FooterBottomstyle: {
        padding: '15px 0px',
        backgroundColor: '#000',
        textAlign: 'center'
    },
    RightsStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#364252',
    },
    RegisterboxStyle: {
        padding: "30px 20px",
        borderRadius: "20px",
        border: "1px solid #e5e5e5",
        backgroundColor: "#fff",
        maxWidth: "100%",
        margin: "auto",
    },
    RegisterHeading: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "30px",
        fontWeight: "bold",
        textAlign: "center",
        color: "#1d1d1d",
    },
    TicketsStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "16px",
        fontWeight: "normal",
        textAlign: "center",
        color: "#717182",
    },
    CommonLabelName: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "14px",
        fontWeight: "600",
        textAlign: "left",
        color: "#030213",
        marginBottom: '3px',
    },
    FilterStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "17px",
        fontWeight: 600,
        textAlign: "left",
        color: "#0e182b",
    },
    FilterNumber: {
        padding: "3px 8px",
        borderRadius: "7px",
        backgroundColor: "#eceff2",
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "13px",
        fontWeight: 600,
        textAlign: "center",
        color: "#0e182b",
    },
    FilterLabel: {
        "& .MuiFormControlLabel-label": {
            fontFamily: '"Segoe UI", sans-serif',
            fontSize: "14px",
            fontWeight: 500,
            color: "#364252",
        },
    },
    Valuenumberstyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "16px",
        fontWeight: "600",
        color: "#364252",
    },
    BusesStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "20px",
        fontWeight: 600,
        textAlign: "left",
        color: "#1d1d1d",
        display: 'flex',
        alignItems: 'center',
        marginBottom: '15px',
    },
    LimitedText: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '17px',
        fontWeight: 600,
        textAlign: 'left',
        color: '#0e182b',
    },
    FirstBooking: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '15px',
        fontWeight: '600',
        fontStretch: 'normal',
        textAlign: 'left',
        color: '#00823b',
    },
    CouponCode: {
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center',
        color: '#fff',
        padding: '7px 12px',
        borderRadius: '8px',
        backgroundColor: '#00a546',
        marginRight: '15px',
    },
    OrangeTravelsStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "17px",
        fontWeight: 600,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.34px",
        textAlign: "left",
        color: "#0e182b",
        marginBottom: '3px',
    },
    OrangeTravelsStyle1: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "17px",
        fontWeight: 600,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.34px",
        textAlign: "left",
        color: "#0e182b",
        marginBottom: '3px',
    },
    SeaterText: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: "14px",
        fontWeight: "normal",
        textAlign: "left",
        color: "#364252",
    },
    CountNumberTotal: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '23px',
        fontWeight: 'bold',
        textAlign: 'right',
        color: '#1d1d1d',
    },
    CountNumberTotal1: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '16px',
        fontWeight: '500',
        textAlign: 'right',
        color: '#1d1d1d',
    },
    SeatsStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#bf695d'
    },
    SeatSelectionstyle: {
        background: '#a4cef8',
        padding: '3px 10px',
        borderRadius: '5px',
        color: "#0e182b",
        fontWeight: '500',
        fontFamily: '"Segoe UI", sans-serif',
        marginTop: '10px',
        fontSize: '13px',
    },
    SeatBoxStyle: {
        padding: "10px 10px",
        borderRadius: "12px",
        borderBottom: "solid 1px #f5f5f5",
        backgroundColor: "#ebe9e9",
        "@media (max-width:600px)": {
            height: '180px',
        },


    },
    BookingStyle: {
        fontFamily: "Segoe UI, sans-serif",
        fontSize: "17px",
        fontWeight: 600,
        textAlign: "left",
        color: "#0e182b",
    },
    DateStyle: {
        fontFamily: "Segoe UI, sans-serif",
        fontSize: "12px",
        fontWeight: "normal",
        color: "#717182",
        display: 'block',
    },
    ProfileHead: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '17px',
        fontWeight: 600,
        textAlign: 'left',
        color: '#0e182b',
    },
    Subheading: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.24px',
        textAlign: 'left',
        color: '#717182',
        marginBottom: '5px',
    },
    MessageRecivesd: {
        padding: '10px',
        borderRadius: '8px',
        backgroundColor: '#f3f3f5',
    },
    TodayText: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '15px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#717182',
    },
    Timedate: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: 12,
        fontWeight: 400,
        textAlign: 'left',
        color: '#717182',
    },
    MessageSender: {
        padding: '10px',
        borderRadius: '8px',
        backgroundColor: '#ff5714',
    },
    TodayText1: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '15px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#fff',
    },
    Timedate1: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: 12,
        fontWeight: 400,
        textAlign: 'left',
        color: '#fff',
    },
    QuickLinks: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: 13,
        fontWeight: 400,
        lineHeight: 2.31,
        letterSpacing: '0.26px',
        textAlign: 'left',
        color: '#000',
        textDecoration: 'unset',
        padding: '3px 13px',
        borderRadius: '6px',
        border: 'solid 1px #ececf0',
        width: '100%',
        display: 'block',
        marginBottom: '10px',
    },
    CancelationStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: 14,
        fontWeight: 600,
        textAlign: 'left',
        color: '#00c950',
    },
    CancelationDate: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: 13,
        fontWeight: 400,
        letterSpacing: '0.26px',
        textAlign: 'left',
        color: '#717182',
    },
    ProcessingStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: 14,
        fontWeight: 600,
        textAlign: 'left',
        color: '#717182',
    },
    ProcessingExpected: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: 14,
        fontWeight: 'normal',
        textAlign: 'right',
        color: '#588dff',
    },
    CallTextStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '13px',
        fontWeight: '500',
        textAlign: 'left',
        color: '#000',
        padding: '10px',
        borderRadius: '6px',
        border: '1px solid #ececf0',
        marginTop: '13px',
    },
    PhoneStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '12px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#208b3d',
        padding: '3px 6px',
        borderRadius: '6px',
        backgroundColor: '#c5ffd5',
    },
    CommonBookStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '13px',
        fontWeight: '500',
        fontStretch: 'normal',
        textAlign: 'left',
        color: '#717182',
    },
    SubCommunTicket: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '14px',
        fontWeight: 600,
        textAlign: 'left',
        color: '#0e182b',
        marginBottom: '20px',
    },
    BookBorderStyle: {
        padding: '15px',
        borderRadius: '12px',
        border: '1px solid #ffe145',
        backgroundColor: '#fff',
    },
    BooktextStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '16px',
        fontWeight: 400,
        textAlign: 'left',
        color: '#1d1d1d',
        "@media (max-width:600px)": {
            marginLeft: '9px',
        },
    },
    BooktextStyle1: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '13px',
        fontWeight: 400,
        fontStretch: 'normal',
        textAlign: 'left',
        color: '#717182',
    },
    BookingStyle: {
        fontFamily: '"Segoe UI", sans-serif',
        fontSize: '10px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#030213',
        padding: '5px 10px',
        borderRadius: '6px',
        backgroundColor: '#eceef2',
        marginTop: '5px',
        marginRight: '10px',
    }
};

export default styleCss;